import { Link } from 'react-router-dom';
import { VAULT } from '../constants/testIds';

const formatPrice = (p) =>
  p >= 1_000_000 ? `$${(p / 1_000_000).toFixed(2)}M` : `$${p.toLocaleString()}`;

export const PropertyCard = ({ property, size = 'normal' }) => {
  const isLarge = size === 'large';
  return (
    <Link
      to={`/vault/${property.id}`}
      data-testid={VAULT.cardLink(property.id)}
      className="group block relative overflow-hidden bg-[#0A0A0A] no-radius"
    >
      <div className={`relative overflow-hidden ${isLarge ? 'aspect-[16/10]' : 'aspect-[4/5]'}`}>
        <img
          src={property.hero_image}
          alt={property.title}
          className="vault-img absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute top-5 left-5 right-5 flex items-start justify-between">
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 px-3 py-1 bg-black/40 backdrop-blur-sm">
            {property.listing_type}
          </span>
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#F5F5F5] bg-black/40 backdrop-blur-sm px-3 py-1">
            {property.country}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-2">{property.region}</div>
          <h3 className={`font-light leading-tight mb-3 text-white ${isLarge ? 'text-3xl md:text-4xl' : 'text-xl md:text-2xl'}`}>
            {property.title}
          </h3>
          <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] uppercase text-[#A3A3A3]">
            <span>{property.bedrooms} Bd</span>
            <span className="w-1 h-1 bg-[#D4AF37]"></span>
            <span>{property.bathrooms} Ba</span>
            <span className="w-1 h-1 bg-[#D4AF37]"></span>
            <span>{property.area_sqft.toLocaleString()} sqft</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between px-6 md:px-8 py-5 border-t border-[#D4AF37]/15">
        <div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-1">Valuation</div>
          <div className="font-display text-2xl text-[#D4AF37]">{formatPrice(property.price_usd)}</div>
        </div>
        {property.yield_estimate && (
          <div className="text-right">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-1">Yield</div>
            <div className="font-display text-2xl text-[#F5F5F5]">{property.yield_estimate}%</div>
          </div>
        )}
      </div>
    </Link>
  );
};

export { formatPrice };
